import { TimePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { FC, useState } from "react";
import { Control, Controller, FieldValues } from "react-hook-form";

const roundToStep = (date: moment.Moment) => {
  if (!date.isValid()) return null;
  const minutes = date.minutes();
  const rounded = minutes < 15 ? 0 : minutes < 45 ? 30 : 0;
  const hour = minutes >= 45 ? date.hour() + 1 : date.hour();
  return date.clone().hour(hour).minutes(rounded).seconds(0).milliseconds(0);
};

interface TimeInputProps {
  restProps: any;
  label: string;
  id: string;
  disableFuture?: boolean | undefined;
  disablePast?: boolean | undefined;
  control: Control<FieldValues, any>;
  errors: any;
}

const TimeInput: FC<TimeInputProps> = ({
  label,
  id,
  disableFuture,
  disablePast,
  control,
  errors,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex gap-[10px] flex-col">
      <label htmlFor={id} className="">
        {label}
      </label>
      <Controller
        name={id}
        control={control}
        render={({ field }) => {
          return (
            <TimePicker
              onChange={(time) => {
                const rounded = time ? roundToStep(moment(time)) : null;
                field.onChange(rounded ? rounded.format("HH:mm") : null);
                setIsOpen(false);
              }}
              ampm={false}
              timeSteps={{ minutes: 30 }}
              className="bg-white rounded-md w-full h-full "
              sx={{
                "& fieldset": { top: "-6px" },
                button: {
                  color: "rgba(0, 0, 0, 0.54)",
                  backgroundColor: "white",
                  ":hover": {
                    backgroundColor: "#E0E0E0",
                    color: "rgba(0, 0, 0, 0.54)",
                  },
                },
              }}
              disableFuture={disableFuture}
              disablePast={disablePast}
              shouldDisableTime={(time) => {
                const value = moment(field.value, "HH:mm");
                const candidate = moment(time, "HH:mm");
                if (candidate.isSame(value, "minute")) {
                  return false;
                }

                const now = moment();
                if (disablePast && candidate.isBefore(now, "minute")) {
                  return true;
                }
                if (disableFuture && candidate.isAfter(now, "minute")) {
                  return true;
                }
                return false;
              }}
              open={isOpen}
              onClose={() => setIsOpen(false)}
              slotProps={{
                textField: {
                  onClick: () => setIsOpen(true),
                },
                openPickerButton: {
                  onClick: () => setIsOpen(true),
                },
              }}
              value={
                field.value && moment(field.value, "HH:mm").isValid()
                  ? roundToStep(moment(field.value, "HH:mm"))
                  : null
              }
              format="HH:mm"
            />
          );
        }}
      />
      <div className="text-red-600 text-sm cursor-default">
        {errors[id]?.message}
      </div>
    </div>
  );
};

export default TimeInput;
